import { render, staticRenderFns } from "./Modifiers.vue?vue&type=template&id=7c3354fd&scoped=true"
import script from "./Modifiers.vue?vue&type=script&lang=js"
export * from "./Modifiers.vue?vue&type=script&lang=js"
import style0 from "./Modifiers.vue?vue&type=style&index=0&id=7c3354fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3354fd",
  null
  
)

export default component.exports